import { InputAdornmentButton } from '@cian/ui-kit';
import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectHasRegionalDistricts } from 'shared/selectors/location';
import { RegionalDistrictsModalContainer } from '../ModalContainer';
import { useAppDispatch, useModalState } from 'shared/hooks';
import { loadRegionalDistricts, syncRegionalDistricts } from 'shared/thunks/geo/regionalDistricts';
import { selectNeedRegionalDistrictsRequest } from 'shared/selectors/geo';
import { trackGeoSuggestClick } from 'shared/utils/analytics';

export const RegionalDistrictsPopupButtonContainer: FC = () => {
  const dispatch = useAppDispatch();
  const hasRegionalDistricts = useSelector(selectHasRegionalDistricts);
  const needRequestData = useSelector(selectNeedRegionalDistrictsRequest);

  const { opened, onClose, onOpen } = useModalState();

  const handleOpen = useCallback(() => {
    onOpen();

    if (needRequestData) {
      dispatch(loadRegionalDistricts());
    }

    dispatch(syncRegionalDistricts());
    trackGeoSuggestClick('district');
  }, [dispatch, needRequestData, onOpen]);

  if (!hasRegionalDistricts) {
    return null;
  }

  return (
    <>
      <InputAdornmentButton type="button" onClick={handleOpen}>
        Район
      </InputAdornmentButton>
      {opened && <RegionalDistrictsModalContainer onModalClose={onClose} />}
    </>
  );
};
